import { useState } from "react";
import { api } from "../../../helpers/api";
import { ShowToast } from "../../../components/toast";
import { PopupModal } from "../../../components/Modal";
import Button from "../../../components/Button";

export function ConfirmDelete({
  onClose,
  userId,
  refetch,
}: {
  onClose: () => void;
  userId: string;
  refetch: () => void;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const handleDelete = () => {
    setIsLoading(true);
    api
      .deleteUser(userId)
      .then(() => {
        onClose();
        ShowToast({
          message: "User deleted successfully",
          type: "success",
        });
        refetch && refetch();
        setIsLoading(false);
      })
      .catch(() => {
        ShowToast({
          message: "Failed to delete user",
          type: "error",
        });
        setIsLoading(false);
      });
  };

  return (
    <PopupModal onClose={onClose} contentClassName="w-[500px] mx-auto">
      <p>
        Are you sure you want to delete this user? This action cannot be undone.
      </p>
      <div className="flex flex-row gap-4 ml-auto">
        <Button variant="outline" className="px-8" onClick={onClose}>
          Cancel
        </Button>
        <Button
          className="px-8 text-[1rem]"
          onClick={handleDelete}
          loading={isLoading}
        >
          Delete
        </Button>
      </div>
    </PopupModal>
  );
}
